const config = {
    API_URL: "https://api.skynyx.ai/public/api",
    // API_URL: "http://127.0.0.1:8000/api",
};

export default config;
